import { logout } from "./logout.resource.js";
import { handleError } from "src/error";

export function actuallyLogoutOfApp(urlQueryParams) {
  const originStr = ensurePageReload(window.location.origin);
  const typeStr = window.appIsMobile ? "m" : "#";
  const urlQueryParamsStr = urlQueryParams || "";

  const loginUrl = `${originStr}/${typeStr}/login${urlQueryParamsStr}`;

  clearUserDataFromLocalStorage();
  logout().subscribe(() => window.location.assign(loginUrl), handleError);

  return loginUrl;
}

function clearUserDataFromLocalStorage() {
  const localStorageToKeep = [
    "login-page:canopy-password",
    "sofe",
    "cp:sofe-inspector",
    "feature:",
    "canopy-squad",
    "cp-admin-advanced-search-toggle",
    "saved-time-filter",
    "cp:AI_Email_Style",
    "cp:AI_Email_Tones",
    "optout",
    "optin",
    "-bubbleList",
    "__ugApiEventsPushed", // userguiding
    "___ug___", // userguiding
    "__UGS__uid", // userguiding
    "canopy_payments_banner", // app-dashboard banner
  ];
  for (let i in window.localStorage) {
    if (!localStorageToKeep.some((keep) => i.includes(keep))) {
      // not a reserved item
      localStorage.removeItem(i);
    }
  }
}

export function ensurePageReload(url) {
  // We want to force a page reload on sign out because not all child applications unmount everything correctly
  // and they don't handle the global user and tenant changing.
  // For example, modals created by one child app but that are rendered by a different sofe service.
  // The only way I know of to force a reload when navigating to the same domain is to change the
  // protocol in the url. Since the load balancer auto-redirects from http -> https, this works.
  if (url.startsWith("https")) {
    return "http" + url.slice("https".length);
  } else {
    return url;
  }
}
